import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default class LaunchpadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('SuperAdminLaunchpad crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section
          className="glass rounded-xl border border-status-degraded/30 p-5"
          data-testid="super-admin-launchpad-error"
        >
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-status-degraded flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="font-heading font-bold text-foreground">Platform launchpad unavailable</h2>
              <p className="text-xs text-muted-foreground mt-1">
                The launchpad could not be displayed. The rest of the dashboard remains available below.
              </p>
            </div>
          </div>
        </section>
      );
    }

    return this.props.children;
  }
}
